import { createContext } from 'react'

const KanbanListContext = createContext()

export default KanbanListContext
